import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const bull = (
    <Box
        component="span"
        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
        •
    </Box>
);

export default function JobDetail(props) {
    const { data } = props
    const close = () => {
        props.closeDialog(false)
    }
    const card = (
        <React.Fragment>
            <CardContent>
                {data.map((item) => (
                    <>
                        <Typography sx={{ fontSize: 14 }} gutterBottom key={item.DOCNO}>
                            <span>เลขที่เอกสาร : </span>  {item.DOCNO}
                        </Typography>

                        <Typography sx={{ fontSize: 14 }} gutterBottom key={item.FIRST_NAME + "  " + item.LAST_NAME}>
                            <span>ชื่อลูกค้า : </span>  {item.FIRST_NAME + "  " + item.LAST_NAME}
                        </Typography>

                        <Typography sx={{ fontSize: 14 }} gutterBottom key={item.JOB_OPERATION}>
                            <span>ประเภทการซ่อม : </span>  {item.JOB_OPERATION}
                        </Typography>

                        <Typography sx={{ fontSize: 14 }} gutterBottom key={item.MILAGE}>
                            <span>เลขไมล์ : </span>  {item.MILAGE}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }} gutterBottom key={item.MOBILE_NO}>
                            <span>เลขเครื่อง : </span>  {item.MOBILE_NO}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }} gutterBottom key={item.MOBILE_NO}>
                            <span>เลขตัวถัง : </span>  {item.VIN_NO}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }} gutterBottom key={item.START_DATE}>
                            <span>วันที่ : </span>  {item.START_DATE}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }} gutterBottom key={"รายการอะไหล่"}>
                            <span>รายการอะไหล่  </span>
                        </Typography>
                        {item.JOB_DETAILS.map((itemJob) => (
                            <>
                                <Typography sx={{ fontSize: 14 }} gutterBottom key={itemJob}>
                                    <span>สินค้า: </span> {itemJob.PRODUCTCODE} {itemJob.PARTS_SERVICE_NAME}   <span> ประเภท: </span> {itemJob.ITEM_TYPE}
                                </Typography>
                            </>
                        ))}
                    </>
                ))}
            </CardContent>
            <CardActions>
                <Button size="small" onClick={_ => close()}>ปิด</Button>
            </CardActions>
        </React.Fragment>
    );
    return (
        <Box sx={{ minWidth: 275 }}>
            <Card variant="outlined" >
                {card}
            </Card>
        </Box>
    )
}
